import { Theme } from '../theme';
import { useMediaQuery } from '@mui/material';

export function useShouldModalBeFullscreen() {
  return useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'));
}
